import maldivesCharterTakeoverConfig from 'takeovers/maldivesCharterTakeover/maldivesCharterTakeoverConfig'
import loyaltyChooseDoubleRewardsTakeoverConfig from 'takeovers/loyaltyChooseDoubleRewardsTakeover/loyaltyChooseDoubleRewardsTakeoverConfig'

import { TakeoverId } from '../client/lib/lab/dynamicPayload'

export { TakeoverId }

export const takeovers: Record<TakeoverId, App.SiteTakeoverConfig | undefined> = {
  [TakeoverId.MALDIVES_CHARTER_TAKEOVER]: maldivesCharterTakeoverConfig,
  [TakeoverId.SOCIETE_CHOOSE_DOUBLE_REWARDS_TAKEOVER]: loyaltyChooseDoubleRewardsTakeoverConfig,
} as const
